import * as React from "react";
import { withTheme } from "../../../../../../common/withTheme";

class PageAPC extends React.PureComponent<any, any> {
	constructor(props, context) {
		super(props, context);
	}

	render() {
		return (
			<>
				<h2>Australian Platypus Conservancy</h2>
                <p>
                    The Australian Platypus Conservancy is a non-government, non-profit organisation dedicated to conserving the platypus and its freshwater habitats.
                </p>
                <p>
                    Since being founded in 1994, the Conservancy has conducted a wide range of research projects.  This work has included many hundreds of overnight live-trapping surveys and studies contributing to a much better understanding of platypus population dynamics, habitat and stream flow requirements, home range size and dispersal, activity patterns, and factors contributing to platypus mortality.
                </p>
                <p>
                    In 2008, the APC initiated <em>Platypus Count</em>, a new approach to monitoring platypus population trends based on sightings made by volunteers using a standardised visual survey method.  This, in turn, has made it possible to create the Australian Platypus Monitoring Network.
                </p>
                <p>
                    As a result of the APC’s work, much more is now known about the platypus’s status and environmental needs and the key threats facing its survival.  The APC also continues to work hard to ensure that research findings are linked to practical action by management agencies, community groups, businesses and private landowners to protect platypus populations.
                </p>
                <p>
                    For more information about the Australian Platypus Conservancy and platypus biology and conservation, go to <a target="_blank" href="https://www.platypus.asn.au">www.platypus.asn.au</a>.
                </p>
			</>
		);
	}
}

export default withTheme<any>(PageAPC);
